import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export default styled.span`
  color: #f80606;
  flex-shrink: 0;
  font-size: 14px;
  padding: 10px 0;
  max-width: 100%;

  ${media.lg`
    display: block;
    padding: 0 0 0 10px;
    text-align: left;
    max-width: ${({ width }) => width};
    width: 100%;
  `}
`;
